<swiper [config]="dynamicCategory.swiperConfig">
  <ng-template *ngFor="let category of dynamicCategory.categories" swiperSlide>
    <custom-dot-cms-category-card [stylesCSS]="dynamicCategory.contentlet.listItemCssClass" [category]="category"
      [layout]="dynamicCategory.contentlet.layout"></custom-dot-cms-category-card>
  </ng-template>
</swiper>

<!-- <div class="animated-element image-wrapper shine"> -->